<script>
  import Common from "./TermsCommon.svelte";
  import Aichi from "./TermsAichi.svelte";
  import { terms } from "../stores.js";
</script>

{#if "Aichi" === $terms}
<Aichi />
{:else}
<Common />
{/if}
